<template>
  <div class="chunk">
    <div class="video">
      <div class="hint" v-if="videoList.length === 0">暂无视频</div>
      <div class="video-list" v-else>
        <div class="video-list-children" v-for="(item, index) in videoList" :key="index">
          <video
            style="width: 100%; height: 150px; object-fit: fill; display: block;"
            :poster="item.pictureUrl"
            :src="item.url"
            controls
            autobuffer
          ></video>
          <div class="video-list-name">{{item.name}}</div>
        </div>
      </div>
      <div class="footer" v-if="videoList.length > 0">
        <Page
          :total="videoTotal"
          :page-size="15"
          :current.sync="videoCurrent"
          show-total
          @on-change="changePage"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoList: [],
      videoTotal: 0,
      videoCurrent: 1
    };
  },
  created() {
    this.getVideoList(this.videoCurrent);
  },
  methods: {
    getVideoList(index) {
      this.$http.get(`/video/open?page=${index}&limit=15&sort=rank,ASC`).then(res => {
        this.videoList = res.data.data;
        this.videoTotal = res.data.meta.total;
      });
    },
    changePage(index) {
      this.getVideoList(index);
    }
  }
};
</script>

<style lang="scss" scoped>
.chunk {
  padding-bottom: 116px;
  min-height: 700px;
}
.video {
  min-height: 600px;
  width: 1200px;
  background: #fff;
  padding: 16px;
  &-list {
    display: flex;
    flex-wrap: wrap;
    &-children {
      margin: 8px;
      width: 217px;
    }
    &-name {
      margin-top: 5px;
      padding: 0 2px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-align: center;
    }
  }
}
.footer {
  display: flex;
  justify-content: flex-end;
  margin: 20px 12px 0 0;
}
.hint {
  font-size: 30px;
  color: #cccccc;
  text-align: center;
  margin-top: 100px;
}
</style>